import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "row"]

  toggle(event) {
    event.preventDefault()
    const button = event.currentTarget
    const taskId = button.dataset.taskId

    if (!taskId) return

    // Optimistic UI update
    // From the parent: the button carries data-task-id itself.
    const row = button.parentElement?.closest("[data-task-id]") || button.closest(".flex")
    // The title paragraph; the row's first span is the drag handle.
    const titleElement = row?.querySelector("p")
    const icon = button.querySelector("svg")

    // Mark it done on screen right away. One way only: the endpoint only
    // ever completes, so a second click must not show the task as open again
    // while the record says done (committee 2026-09-29). The button locks.
    if (icon) {
      icon.setAttribute("fill", "currentColor")
      icon.removeAttribute("stroke")
      icon.classList.remove("text-[#E8E4DF]", "text-[#C0C0C0]", "hover:text-[#C4A484]")
      icon.classList.add("text-[#9CAF88]")
      if (titleElement) {
        titleElement.classList.add("line-through", "text-[#8C8C8C]")
      }
      if (row) {
        row.classList.add("mc-highlight-yellow")
        setTimeout(() => {
          row.classList.remove("mc-highlight-yellow")
          row.classList.add("mc-task-complete")
        }, 500)
      }
    }
    button.disabled = true
    button.classList.replace("cursor-pointer", "cursor-not-allowed")

    // Send PATCH request to server
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(`/admin/tasks/${taskId}/complete`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      }
    }).then(response => {
      // fetch resolves on a 404 or 500 too; a refused save must not stay
      // looking done (2026-09-29).
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
    }).catch(error => {
      console.error("Failed to update task:", error)
      // Revert UI on error (reload page as simple fallback)
      window.location.reload()
    })
  }

  add(event) {
    const timeSlot = event.currentTarget.dataset.time
    // Open new task form with pre-filled time slot
    const url = new URL("/admin/tasks/new", window.location.origin)
    url.searchParams.set("scheduled_time_slot", timeSlot)
    url.searchParams.set("scheduled_date", new Date().toISOString().split("T")[0])

    // Use Turbo to navigate or open modal
    window.Turbo?.visit(url.toString()) || (window.location.href = url.toString())
  }
}
